import React from "react";
import moment from "moment";
import StatusChip from "../components/StatusChip";
import Date from "../components/Date";
import { Typography } from "@plum-xoxo/admin-dsm";

export const EMPULS_STATUS_PAYMENTS = [
  {
    label: "Complete",
    value: "Complete",
  },
  // {
  //     label : "Cancelled",
  //     value : "Cancel"
  // },
  {
    label: "Finance Pending",
    value: "Finance pending",
  },
];
export const EMPULS_PAYMENT_REPORT_TABLE_CONST_KEYS = [
  {
    name: "invoice_number",
    label: "Invoice Number",
    defaultChecked: true,
    options: { sort: false },
  },
  {
    name: "total",
    label: "Amount",
    defaultChecked: true,
    options: { sort: false },
  },
  {
    name: "invoice_date",
    label: "Invoice date (UTC)",
    options: {
      sort: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    name: "date_added",
    label: "Recharge on (UTC)",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return moment(value, "YYYY-MM-DD").format("MMM D, YYYY");
      },
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    name: "status",
    label: "Status",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
    },
  },
  {
    name: "action",
    label: "Action",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];
export const EMPULS_INVOICE_REPORT_TABLE_CONST_KEYS = [
  {
    name: "invoice_number",
    label: "Invoice Number",
    defaultChecked: true,
    options: { sort: false },
  },
  {
    name: "total",
    label: "Amount",
    defaultChecked: true,
    options: { sort: false },
    setCellProps: () => ({
      style: {
        wordBreak: "break-word",
      },
    }),
  },
  {
    name: "invoice_date",
    label: "Invoice date (UTC)",
    options: {
      sort: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    name: "date_added",
    label: "Recharge on (UTC)",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return moment(value, "YYYY-MM-DD").format("MMM D, YYYY");
      },
    },
  },
  {
    name: "status",
    label: "Status",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return <StatusChip value={value} />;
      },
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
    },
  },
  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];

export const EMPULS_REDEMPTION_HISTORY = [
  {
    name: "order_id",
    label: "Order Id",
    defaultChecked: true,
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "order_id" },
      ],
    },
  },
  {
    name: "receiver_email",
    label: "Recipients Email",
    defaultChecked: true,
    options: { sort: false },
  },
  {
    name: "receiver_mobile_number",
    label: "Recipients Phone",
    defaultChecked: true,
    options: { sort: false },
  },
  {
    name: "product_name",
    label: "Product Name",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
  {
    name: "totalDenomination",
    label: "Denomination",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          minWidth: "200px",
          textAlign: "right",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
    },
  },
  {
    name: "quantity",
    label: "Total Quantity",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      customBodyRender: (value) => {
        return value.split(",").reduce((a, b) => a + parseInt(b), 0);
      },
    },
  },
  {
    name: "order_total",
    label: "Order Total",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          minWidth: "200px",
          textAlign: "right",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
    },
  },
  {
    name: "order_product_status",
    label: "Status",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
  },
  {
    name: "added_date",
    label: "Order Date (UTC)",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({ style: { minWidth: "140px" } }),
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {moment(value, "YYYY-MM-DD").format("MMM D, YYYY")}
          </span>
        );
      },
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    name: "points",
    label: "Consumed points",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
    },
  },
  {
    name: "additional_pay",
    label: "Additional Spend",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "right",
        },
      }),
    },
  },
  { label: " ", name: "action" },
];

export const TPD_COLUMNS = {
  accountspid: {
    name: "tpd_account_sfid",
    label: "Account SFID",
    defaultChecked: false,
    options: { display: false },
  },
  batchId: {
    name: "tpd_badge_id",
    label: "Badge Id",
    defaultChecked: false,
    options: { display: false },
  },
  citydisplay: {
    name: "tpd_country",
    label: "Country Id",
    defaultChecked: false,
    options: { display: false },
  },
  transactionId: {
    name: "tpd_transaction_id",
    label: "Transaction Id",
    defaultChecked: false,
    options: { display: false },
  },
  userId: {
    name: "tpd_user_id",
    label: "User Id",
    defaultChecked: false,
    options: { display: false },
  },
};

export const DISCOUNT_COLUMNS = [
  {
    name: "product_discount",
    label: "Discount %",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      customBodyRender: (value) => {
        return value + "%";
      },
    },
  },
  {
    name: "discountValue",
    label: "Discount Value",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
    },
  },
];
